import { fetch as fetchPolyfill } from 'whatwg-fetch';

export const postData = (url, data) => {
	return fetchPolyfill(url, {
		method: 'POST',
		body: JSON.stringify(data),
		headers: {
			'X-Api-Key': 'Nb3CLTpyTH1eIjljPAJD94eIyS2BBHda9QWn3Nj9',
			'Content-Type': 'application/json',
		},
	}).then((res) => res);
};

export const checkKeyEvent = (event, key, callback) => {
	if (event.key === key) {
		callback(event);
	}
};
